export interface LoggedUser {
  userId: string;
  token: string;
}
import { values } from 'office-ui-fabric-react';
import {LOCALSTORAGE_KEYS } from '../utils/Constants';
import { getDecodedAccessToken } from '../services/tokenManager';


export const getTokenByProfileEmail = (profileEmail: string): string | null => {
  const STORAGE_KEY = LOCALSTORAGE_KEYS.LoggedUsers;
  const users: LoggedUser[] = JSON.parse(getStorageItem(STORAGE_KEY) || "[]");
  const foundUser = users.find(user => user.userId === profileEmail);

  if (foundUser) {
    // console.log("Token found In helper:", foundUser);
    //   localStorage.setItem("PreviousEmail", profileEmail);
    //   localStorage.setItem("AccessToken", foundUser.token);
    return foundUser.token;
  } else {
    console.warn("Token not found for email:", profileEmail);
    return null;
  }
};

export const getProfileByEmail = (profileEmail: string): string | null => {
  const STORAGE_KEY = LOCALSTORAGE_KEYS.LoggedUsers;
  const users: LoggedUser[] = JSON.parse(getStorageItem(STORAGE_KEY) || "[]");
  const foundUser = users.find(user => user.userId === profileEmail);

  if (foundUser) {
    // console.log("User found In helper:", foundUser);
    //   localStorage.setItem("PreviousEmail", profileEmail);
    //   localStorage.setItem("AccessToken", foundUser.token);
    return foundUser.userId;
  } else {
    console.warn("User not found for email:", profileEmail);
    return null;
  }
};


export const removeUserByProfileEmail = (profileEmail: string): string | null => {
  const STORAGE_KEY =  LOCALSTORAGE_KEYS.LoggedUsers;
  const users: LoggedUser[] = JSON.parse(getStorageItem(STORAGE_KEY) || "[]");

  const updatedUsers = users.filter(user => user.userId !== profileEmail);

  // If no user was removed, return null
  if (updatedUsers.length === users.length) {
    return null;
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedUsers));
  return profileEmail; // Return removed email as confirmation
};

export const fetchAccessToken = async (getAccessTokenSilently, propName = LOCALSTORAGE_KEYS.AuthToken) => {
  try {
    let token = await getAccessTokenSilently();

    if (!token) {
      token = getStorageItem(propName);
    }

    if (token) {
      SetStorageItem(propName, token);
    }
    return token;
  } catch (error) {
    console.error("Error fetching access token:", error);
    return null;
  }
};

export const getTokenByLocalStorage = async() => {
  try {
    const token = getStorageItem(LOCALSTORAGE_KEYS.AuthToken);
    return token || null; // Ensure null is returned if token is empty or undefined
  } catch (error) {
    console.error("Error accessing localStorage:", error);
    return null;
  }
};


export function extractTenantIdFromToken() {
  // Access token now lives in tokenManager's in-memory store rather than
  // localStorage (see src/services/tokenManager.ts) - decode from there
  // instead. Same claims, same JWT, just no longer persisted to storage.
  const payload = getDecodedAccessToken();
  if (!payload) return '';
  return (
    payload["https://clarra/tenantId"] ||
    payload.tid ||
    payload.tenantId ||
    ''
  );
}


export function  getStorageItem(key) {
  try {
    const Value = localStorage.getItem(key);
    return Value || null; // Ensure null is returned if token is empty or undefined
  } catch (error) {
    console.error("Error accessing localStorage:", error);
    return null;
  }
};

export function SetStorageItem(key, data)  {
  try {
    localStorage.setItem(key, data);
  } catch (error) {
    console.error("Error setting localStorage:", error);
    return null;
  }
};

export function RemoveStorageItem(key)  {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing localStorage:", error);
    return null;
  }
};
